import { render } from "./TertiarySelection.vue?vue&type=template&id=6d3fae1a&scoped=true"
import script from "./TertiarySelection.vue?vue&type=script&lang=js"
export * from "./TertiarySelection.vue?vue&type=script&lang=js"

import "./TertiarySelection.vue?vue&type=style&index=0&id=6d3fae1a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3fae1a"]])

export default __exports__